import React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { TypedTranslateHtml } from '@change-corgi/core-react/i18n';

import { usePolicyInfo } from './hooks/usePolicyInfo';

type Props = {
	useDonationLanguage: boolean;
};

export const PolicyInfo: React.FC<Props> = ({ useDonationLanguage }) => {
	const {
		data: { termsOfServiceLink, termsOfServiceLinkText, privacyPolicyLink, privacyPolicyLinkText, policyInfoText },
	} = usePolicyInfo({ useDonationLanguage });

	return (
		<Text as="span" variant="body" className="text-size-body-xs text-typography-strong md:text-size-body-small">
			<TypedTranslateHtml
				value={policyInfoText}
				replacements={{
					termsOfServiceLink: (
						<Link href={termsOfServiceLink} target="_blank" rel="noreferrer" data-qa="terms-of-service-link">
							<Text variant="body" className="text-size-body-xs md:text-size-body-small">
								{termsOfServiceLinkText}
							</Text>
						</Link>
					),
					termsOfServiceLinkText,
					privacyPolicyLink: (
						<Link href={privacyPolicyLink} target="_blank" rel="noreferrer" data-qa="privacy-policy-link">
							<Text variant="body" className="text-size-body-xs md:text-size-body-small">
								{privacyPolicyLinkText}
							</Text>
						</Link>
					),
					privacyPolicyLinkText,
				}}
			/>
		</Text>
	);
};
